import {useNavigate} from 'react-router-dom';
import {useToggle} from '@mantine/hooks';
import {
    AiOutlineEdit,
    AiOutlineProfile
} from 'react-icons/ai';
import {IconContext} from 'react-icons';
import {
    FlexiButton,
    FlexiCancelButton
} from "@flexinet/ui-components";
import {useVerifiedPermissions} from "../../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../../config/rbac/actions.ts";
import config from "../config";
import {EditButton} from "../buttons/EditButton.tsx";
import {ReprovisionRecordButton} from "../buttons/ReprovisionRecordButton.tsx";
import {ClonePipelineButton} from "../buttons/ClonePipelineButton.tsx";
import {Pipeline} from "../types";

export const useEditPageTools = (pipeline?: Pipeline) => {

    const navigate = useNavigate();

    const {allowedActions} = useVerifiedPermissions()

    const [mode, toggle] = useToggle(['view', 'edit']);

    const tools = [];

    if (allowedActions.includes(rbacActions.UpdatePipeline)) {
        if (mode === 'edit') {
            tools.push(<FlexiButton variant={'filled'} key={'profile'}
                                    leftSection={<IconContext.Provider value={{size: '24px'}}>
                                        <AiOutlineProfile/></IconContext.Provider>}
                                    onClick={() => toggle()}>Profile</FlexiButton>);
        } else {
            tools.push(<EditButton leftSection={<AiOutlineEdit/>} variant={'filled'}
                                   key={'edit'}>Edit</EditButton>);
        }
    }

    if (pipeline && allowedActions.includes(rbacActions.ReprovisionPipeline)) {
        tools.push(<ReprovisionRecordButton key='reprovision' pipeline={pipeline} variant='filled'/>);
    }

    // FNP-1017: clone is gated on ProvisionPipeline because that is exactly what
    // it does — it opens the provision form pre-filled from this record. No new
    // RBAC action is introduced; anyone who may provision may clone.
    if (pipeline && allowedActions.includes(rbacActions.ProvisionPipeline)) {
        tools.push(<ClonePipelineButton key='clone' pipeline={pipeline} variant='filled'/>);
    }

    tools.push(<FlexiCancelButton key={'close'}
                                  onClick={() => navigate(config.basePath)}/>);

    return {
        mode,
        tools,
    };
};
